import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import getStyleQuery from '../../../utils/tools/getStyleQuery';

export default function BigDataItemSkeleton({ isCarDetailView }: { isCarDetailView?: boolean }) {
    if (isCarDetailView) {
        return (
            <Stack direction="row" gap={{ xs: 1, md: 2 }} alignItems="center" sx={{ [getStyleQuery()]: { flexGrow: 1, width: 1 } }}>
                <Skeleton sx={{ [getStyleQuery()]: { height: (theme) => theme?.rawTypography?.body1?.fontSize, width: (theme) => theme?.rawTypography?.body1?.fontSize, flexShrink: 0 } }} />
                <Stack sx={{ [getStyleQuery()]: { flexGrow: 1, overflow: 'hidden' } }}>
                    <Skeleton variant="text" sx={{ [getStyleQuery()]: { typography: 'caption' } }} />
                    <Skeleton variant="text" sx={{ [getStyleQuery()]: { typography: 'body1' } }} />
                </Stack>
            </Stack>
        );
    }

    return (
        <Stack direction="row" gap={{ xs: 1 }} alignItems="center" sx={{ [getStyleQuery()]: { flexGrow: 1, width: 1 } }}>
            <Skeleton sx={{ [getStyleQuery()]: { height: (theme) => theme?.rawTypography?.body1?.fontSize, width: (theme) => theme?.rawTypography?.body1?.fontSize, flexShrink: 0 } }} />
            <Skeleton variant="text" sx={{ [getStyleQuery()]: { flexGrow: 1, typography: 'body2' } }} />
        </Stack>
    );
}
